import React, { useState } from 'react';
import { SectionInstance } from '../types';
import { ChevronDown } from 'lucide-react';
import InlineEditText from '../InlineEditText';
import { sfHeadline, sfSub } from './sectionHelpers';

interface Props {
  section: SectionInstance;
}

const FaqAccordion: React.FC<Props> = ({ section }) => {
  const c = section.controls;
  const items = (c.items || []) as Array<{ question: string; answer: string }>;
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="sb-render sb-render-faq" style={{ padding: '80px 24px' }}>
      <div style={{ maxWidth: 768, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <InlineEditText
            tag="h2"
            controlKey="headline"
            style={{ fontSize: '2.25rem', marginBottom: 12 }}
          >
            {sfHeadline(c, 'FAQ')}
          </InlineEditText>
          {(sfSub(c) !== undefined || true) && (
            <InlineEditText
              tag="p"
              controlKey="subheadline"
              style={{ fontSize: '1.125rem', color: '#64748b' }}
            >
              {sfSub(c, 'Find answers to common questions')}
            </InlineEditText>
          )}
        </div>
        <div>
          {items.map((item, i) => (
            <div key={i} style={{ borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                style={{
                  width: '100%', padding: '20px 0', textAlign: 'left',
                  background: 'none', border: 'none', cursor: 'pointer',
                  fontSize: '1.125rem', fontWeight: 600,
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                }}
              >
                {item.question}
                <ChevronDown size={20} style={{
                  transform: openIndex === i ? 'rotate(180deg)' : 'none',
                  transition: 'transform 0.2s',
                  flexShrink: 0,
                  marginLeft: 16,
                }} />
              </button>
              {openIndex === i && (
                <div style={{ padding: '0 0 20px', color: '#64748b', lineHeight: 1.6 }}>
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqAccordion;
